import { Flex, Link, Text, VStack, useMediaQuery } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

import { Department } from '@core/app/types/contactsApiType'
import { useAppTheme } from '@core/utils/contexts/ThemeContext/ThemeContext'

interface DepartmentDetailsProps {
    selectedDepartment: Department | null
}

const DepartmentDetails = ({ selectedDepartment }: DepartmentDetailsProps) => {
    const { t } = useTranslation()
    const [isDesktop] = useMediaQuery('(min-width: 1230px)', {
        fallback: false,
    })
    const { appTheme, updateTheme, isExpired } = useAppTheme()

    const textColor = appTheme?.newSettings?.general?.BackgroundText
        ? `#${appTheme?.newSettings?.general?.BackgroundText}`
        : 'text.main'

    const { name = '', department } = selectedDepartment || {}

    const {
        city = '',
        country = '',
        firstAddressLine = '',
        secondAddressLine = '',
        postalCode = '',
        email = '',
        phone = '',
    } = department || {}

    let headingText = name
    let addressText = ''

    // Construct the display text based on available data
    if (city && country && postalCode) {
        headingText = `${postalCode} ${city}\n${country}`
    } else if (city && country) {
        headingText = `${city}\n${country}`
    } else if (country) {
        headingText = `${name}, ${country}`
    }

    if (firstAddressLine && secondAddressLine) {
        addressText = `${firstAddressLine}, ${secondAddressLine}`
    } else if (firstAddressLine) {
        addressText = `${firstAddressLine}`
    }

    if (!selectedDepartment) return null

    return (
        <VStack as={'address'} align="start" spacing={10} fontStyle={'normal'}>
            <VStack align="start" spacing={0} fontStyle={'normal'}>
                {/*<Text fontWeight="600" fontSize="20px">{headingText}</Text>*/}
                {addressText && (
                    <Text fontWeight="600" fontSize="20px" color={textColor}>
                        {addressText}
                    </Text>
                )}
                <Text fontWeight="600" whiteSpace="pre-line" fontSize="20px" color={textColor}>
                    {headingText}
                </Text>
            </VStack>
            {(phone || email) && (
                <Flex gap={isDesktop ? 10 : 5} alignItems={'center'} flexWrap={'wrap'}>
                    {phone && (
                        <VStack align="start" spacing={2} fontStyle={'normal'} mr={10}>
                            <Text fontWeight="600" fontSize="16px" color={textColor}>
                                {t('2')}
                            </Text>
                            <Link fontWeight="500" fontSize="14px" color={'#404040'} href={`tel:${phone}`}>
                                {phone}
                            </Link>
                        </VStack>
                    )}
                    {email && (
                        <VStack align="start" spacing={2} fontStyle={'normal'}>
                            <Text fontWeight="600" fontSize="16px" color={textColor}>
                                {t('92')}
                            </Text>
                            <Link fontWeight="500" fontSize="14px" color={'#2F80ED'} href={`mailto:${email}`}>
                                {email}
                            </Link>
                        </VStack>
                    )}
                </Flex>
            )}
        </VStack>
    )
}

export default DepartmentDetails
